import { Box } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { DEFAULT_LINK_BUTTON_STYLE } from '../../../../utils/styleHelpers';
import { CX_SPEND_LABEL } from './SpendAmountInput';

export interface CxSpendHeaderProps {
  tag?: string;
  action?: { label: string; disabled?: boolean; onClick: () => void };
}

export const CxSpendHeader = ({ tag, action }: CxSpendHeaderProps) => (
  <Box className="flex items-center justify-between gap-2">
    <Box className="flex items-center gap-2">
      <TextSpan
        size="sm"
        weight="medium"
        color="grey8">
        {CX_SPEND_LABEL}
        <TextSpan
          size="sm"
          color="red"
          className="ml-1">
          *
        </TextSpan>
      </TextSpan>
      {tag && (
        <TextSpan
          size="xs"
          weight="medium"
          color="indigo"
          className="whitespace-nowrap rounded-full bg-blue-50 px-2.5 py-0.5">
          {tag}
        </TextSpan>
      )}
    </Box>
    {action && (
      <button
        type="button"
        className={DEFAULT_LINK_BUTTON_STYLE}
        disabled={action.disabled}
        onClick={action.onClick}>
        {action.label}
      </button>
    )}
  </Box>
);
